import React from 'react'

const FailedPaymentIcon = ({
    strokeColor = "var(--color-txt-primary)",
    ...props
  }: any) => {
  return (
    <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.89844 10.5303H21.8984"
      stroke={strokeColor}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4584 21.03H6.34839C2.79839 21.03 1.89844 20.15 1.89844 16.64V8.42004C1.89844 5.24004 2.63841 4.22004 5.42841 4.06004C5.70841 4.05004 6.01839 4.04004 6.34839 4.04004H17.4584C21.0084 4.04004 21.9084 4.92004 21.9084 8.43004V12.84"
      stroke={strokeColor}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8984 22.5303C20.1076 22.5303 21.8984 20.7394 21.8984 18.5303C21.8984 16.3211 20.1076 14.5303 17.8984 14.5303C15.6893 14.5303 13.8984 16.3211 13.8984 18.5303C13.8984 20.7394 15.6893 22.5303 17.8984 22.5303Z"
      stroke={strokeColor}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.9694 19.6503L16.8594 17.5303"
      stroke={strokeColor}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.9481 17.5603L16.8281 19.6703"
      stroke={strokeColor}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.89844 16.5303H9.89844"
      stroke={strokeColor}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  )
}

export default FailedPaymentIcon